import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './styles.module.css';

const Quantity = ({amount, onChange, className}) => (
    <div className={classnames(styles.container, className)}>
        <div
            className={styles.change}
            onClick={() => onChange(amount - 1)}
            onKeyDown={(evt) => (evt.keyCode === 13 || evt.keyCode === 32) && onChange(amount - 1)}
            role="button"
            tabIndex={0}
        >
            –
        </div>
        <div className={styles.amount}>{amount}</div>
        <div
            className={styles.change}
            onClick={() => onChange(amount + 1)}
            onKeyDown={(evt) => (evt.keyCode === 13 || evt.keyCode === 32) && onChange(amount + 1)}
            role="button"
            tabIndex={0}
        >
            +
        </div>
    </div>
);

Quantity.propTypes = {
    amount: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
};

Quantity.defaultProps = {
    className: '',
};

export default Quantity;
